let _App = {
    init : function(readyCB){
        if(window.addEventListener){
            window.addEventListener('load', readyCB);
        }
        else{
            window.attachEvent('onload', readyCB);
        }
    },
};

module.exports = _App;


// WEBPACK FOOTER //
// ./src/control/base/Application.js